export default __webpack_public_path__ + "ea2ad081fd17c80efd9e5bbfc64497ca.png";